import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=bd4380ca&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4380ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd4380ca')) {
      api.createRecord('bd4380ca', component.options)
    } else {
      api.reload('bd4380ca', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=bd4380ca&scoped=true&", function () {
      api.rerender('bd4380ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PN6tOCxVLPMQ/JS/comp/Accordion.vue"
export default component.exports